import { validateTelephone } from '../../../../core/validation/validate';
import { CommentModalForm, CommentModalState } from '../model/model';

interface ValidateProps {
  form: CommentModalForm;
  modal: CommentModalState['modal'];
  userRole: any;
  status: any;
}

export const validate = ({ form, modal, userRole, status }: ValidateProps) => {
  let error = [];

  Object.keys(form).forEach((key) => {
    if (key === 'comment') {
      if (modal.comment && !form[key]) {
        error = [...error, 'comment'];
      } else if (
        modal.comment &&
        form[key].length < 50 &&
        userRole === 'user' &&
        status === 18
      ) {
        error = [...error, 'comment-minlength'];
      }
    } else if (modal.personal) {
      if (!form[key]) {
        error = [...error, key];
      }
      if (
        key === 'sender_phone' &&
        validateTelephone(form[key])?.isError === true
      ) {
        error = [...error, 'sender_phone_fail'];
      }

      if (
        key === 'sender_email' &&
        !/^(|(([A-Za-z0-9А-Яа-я]+_+)|([A-Za-z0-9]+-+)|([A-Za-z0-9А-Яа-я]+\.+)|([A-Za-z0-9А-Яа-я]+\++))*[A-Za-z0-9А-Яа-я]+@((\w+-+)|(\w+\.))*\w{1,63}\.[a-zA-ZА-Яа-я]{2,20})$/i.test(
          form[key],
        )
      ) {
        error = [...error, 'sender_email_fail'];
      }
    }
  });

  return error as string[];
};
